import { Link, useLocation } from 'react-router-dom';
import { useConsumerAuth } from '../context/ConsumerAuthContext.jsx';

const navLinks = [
  { to: '/', label: 'Home', private: false },
  { to: '/verify', label: 'Verify', private: false },
  { to: '/bin-finder', label: 'Find a Bin', private: false },
  { to: '/mail-back', label: 'Mail Back', private: false },
  { to: '/learn', label: 'Learn', private: false },
  { to: '/my-impact', label: 'My Impact', private: true },
];

function Layout({ children }) {
  const location = useLocation();
  const { user, logout } = useConsumerAuth();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-base-200">
      <header className="bg-base-100 shadow-sm">
        <div className="navbar mx-auto max-w-6xl px-4 sm:px-6">
          <div className="navbar-start">
            <Link to="/" className="btn btn-ghost px-0 text-left">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-content shadow-md">
                  <span className="text-xl font-semibold">P</span>
                </div>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.28em] text-primary">PACT COLLECTIVE</p>
                  <p className="text-sm text-neutral">Recycle your beauty empties</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="navbar-center hidden gap-2 lg:flex">
            {navLinks.map((link) => {
              if (link.private && !user) return null;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`btn btn-ghost btn-sm rounded-full ${
                    isActive(link.to) ? 'bg-primary/10 text-primary' : 'text-neutral hover:bg-primary/5'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="navbar-end flex items-center gap-2 text-sm">
            {user ? (
              <>
                <span className="hidden text-neutral sm:inline">Hi, {user.name?.split(' ')[0] || 'friend'}</span>
                <button onClick={logout} className="btn btn-outline btn-sm rounded-full">
                  Log out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost btn-sm rounded-full text-neutral">
                  Log in
                </Link>
                <Link to="/signup" className="btn btn-primary btn-sm rounded-full">
                  Create account
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-12 sm:px-8">{children}</main>

      <footer className="bg-base-100">
        <div className="footer mx-auto max-w-6xl items-center justify-between gap-6 px-4 py-10 text-sm text-neutral sm:px-8">
          <p>&copy; {new Date().getFullYear()} PACT Collective. All rights reserved.</p>
          <div className="flex flex-wrap gap-6">
            <a href="https://www.pactcollective.org/privacy-policy" className="link link-hover">
              Privacy
            </a>
            <a href="https://www.pactcollective.org/contact" className="link link-hover">
              Contact
            </a>
            <a href="https://www.pactcollective.org/become-a-member" className="link link-hover">
              For Brands
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
